export var detachArrayBuffer = function detachArrayBuffer(arrayBuffer) {
  var _MessageChannel = new MessageChannel(),
      port1 = _MessageChannel.port1,
      port2 = _MessageChannel.port2;

  return new Promise(function (resolve) {
    port2.onmessage = function () {
      port1.close();
      port2.close();
      resolve();
    };

    port1.postMessage(arrayBuffer, [arrayBuffer]);
  });
};